module.exports = __webpack_public_path__ + "static/img/4.e517f52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/zncy/zncq/4.png
// module id = vjo4
// module chunks = 1